import {
  Box,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  Popover,
  TextField,
} from "@mui/material";
import React, { FC, SetStateAction, useState } from "react";
import { useAppSelector } from "store";
import { Emoticon as EmoticonIcon, Send as SendIcon } from "mdi-material-ui";
import i18n from "@emoji-mart/data/i18n/pt.json";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

export const TextFieldChat: FC<{
  message: string;
  setMessage: (value: SetStateAction<string>) => void;
  handleSendMsg: () => void;
  disabled?: boolean;
}> = ({ handleSendMsg, message, setMessage, disabled }) => {
  const [anchorEmoticon, setAnchorEmoticon] =
    useState<HTMLButtonElement | null>(null);

  const {
    layout: {
      theme: { mode },
    },
    chat: { options },
  } = useAppSelector((state) => state);

  const podeEnviarEmoji = options.liberarEmoji || false;

  return (
    <Box>
      <Grid container>
        <Grid item xs>
          <TextField
            placeholder="Mensagem..."
            value={message}
            onChange={({ target: { value } }) => setMessage(value)}
            onKeyDown={(e) => {
              if (e.key == "Enter") {
                e.preventDefault();
                handleSendMsg();
              }
            }}
            disabled={disabled}
            fullWidth
            InputProps={{
              startAdornment: podeEnviarEmoji ? (
                <InputAdornment position="start" sx={{ mt: "0 !important" }}>
                  <IconButton
                    aria-label="emotion"
                    onClick={(e) => {
                      setAnchorEmoticon(e.currentTarget);
                    }}
                  >
                    <EmoticonIcon />
                  </IconButton>
                </InputAdornment>
              ) : undefined,
            }}
            sx={{
              "& input": { paddingTop: 1.5, paddingBottom: 1.5 },
              "& .MuiInputBase-root": {
                pl: 0,
                pr: 0,
              },
            }}
          />
        </Grid>
        <Grid item xs="auto">
          <Fab
            disabled={disabled}
            color="secondary"
            sx={({ spacing }) => ({
              position: "relative",
              top: spacing(-0.5),
              right: spacing(-0.5),
            })}
            onClick={handleSendMsg}
          >
            <SendIcon />
          </Fab>
        </Grid>
      </Grid>
      <Popover
        open={Boolean(anchorEmoticon)}
        anchorEl={anchorEmoticon}
        onClose={() => setAnchorEmoticon(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Picker
          data={data}
          theme={mode}
          onEmojiSelect={(args: { native: string }) => {
            setMessage((prev) => prev + args.native);
          }}
          i18n={i18n}
          previewPosition="none"
          skinTonePosition="none"
        />
      </Popover>
    </Box>
  );
};
